import { Button, Tooltip } from 'antd';
import { useWorkorderDetailContext } from '../../WorkorderDetailProvider';
import { useWorkOrderZfGenerateToken } from '@/core/domain/workorder/zf/zf.hooks';
import { WorkOrderComplementStatus } from '@/core/domain/workorder/WorkOrdersComplements/WorkOrdersComplements.types';
import { useColorScheme } from '@/contexts/ColorSchemeContextProvider';

export default function ZfGenerateTokenSSO() {
  const {
    complement: { data: complement },
    workorder: { data: workorder },
    company: { companySettings },
  } = useWorkorderDetailContext();

  const [colorScheme] = useColorScheme();

  const hasVehicle = !!workorder?.vehicle?.id;
  const NotAuthorizedStatus =
    !complement?.status ||
    ![WorkOrderComplementStatus.Authorized].includes(complement?.status);

  const disabled = NotAuthorizedStatus || !hasVehicle;

  const generateToken = useWorkOrderZfGenerateToken();

  const handleGenerateToken = async () => {
    try {
      if (!complement?.id) return;
      await generateToken.mutateAsync(complement?.id);
    } catch {}
  };

  if (!complement?.id || !companySettings?.isAuthorizedToAccessProParts)
    return null;

  return (
    <Tooltip
      title={
        NotAuthorizedStatus
          ? 'Apenas orçamento Autorizado'
          : !hasVehicle
          ? 'Sem veículo vinculado'
          : undefined
      }
    >
      <Button
        disabled={disabled}
        onClick={handleGenerateToken}
        loading={generateToken.isLoading}
        style={{
          paddingBlock: 0,
          backgroundColor: colorScheme === 'dark' ? 'white' : undefined,
        }}
      >
        {generateToken.isLoading ? (
          'Redirecionando...'
        ) : (
          <img
            src="/images/logo-zf-proparts-color.png"
            style={{ height: 24 }}
          />
        )}
      </Button>
    </Tooltip>
  );
}
